module.exports = __webpack_public_path__ + "img/suspend.8de3381f.svg";